import { css } from '@emotion/css';
import c from 'classnames';

const LEFT_HANDLE = css`
  left: 1rem !important;
`;

const RIGHT_HANDLE = css`
  right: 1rem !important;
`;

const BOTTOM_HANDLE = css`
  bottom: 1rem !important;
`;

const TOP_HANDLE = css`
  top: 1rem !important;
`;

export const RESIZE_LEFT = `resize-left-handle ${LEFT_HANDLE}`;
export const RESIZE_RIGHT = `resize-right-handle ${RIGHT_HANDLE}`;
export const RESIZE_BOTTOM = `resize-bottom-handle ${BOTTOM_HANDLE}`;
export const RESIZE_TOP = `resize-top-handle ${TOP_HANDLE}`;

export const NODE_CONTAINER_CLASSNAME = 'node-container ';

export const RESIZER_COMMON_CLASSES = c('absolute rounded-8 z-10 pointer-events-none');

export const widthHandlerStyles = css`
  top: 50%;
  transform: translateY(-50%);
  background: rgba(15, 15, 15, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.9);
`;

export const resizeContainer = css`
  &:hover .resize-handles {
    display: block;
  }
`;

export const heightHandlerStyles = css`
  left: 50%;
  transform: translateX(-50%);
  background: rgba(15, 15, 15, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.9);
`;
